import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { createColumns } from 'components/enhanced/data-grid/utils/ConfigurableColumns';
import { IAccessor } from 'features/inventory/accessories/types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const AccessoryColumns = (): GridColDef[] => {
  const { t } = useTranslation();

  return createColumns<IAccessor>(
    [
      {
        field: 'code',
        headerName: t(`global.code`),
        renderCell: (params: GridRenderCellParams) => (
          <Link to={`${params.row.id}`}>
            <b className="text-secondary-500">{params.row.code}</b>
          </Link>
        )
      },
      { field: 'description', minWidth: 250 },
      { field: 'serial_number', minWidth: 250 },
      { field: 'internal_id', minWidth: 180 },
      { field: 'transport_document_ref', minWidth: 150 },
      { field: 'delivery_date', minWidth: 150 },
      { field: 'installation_date', minWidth: 150 },
      { field: 'testing_date', minWidth: 150 },
      { field: 'buying_date', minWidth: 150 },
      { field: 'decommission_date', minWidth: 150 },
      { field: 'equipment_code', minWidth: 250 },
      {
        field: 'equipment_description',
        minWidth: 250
      },
      { field: 'supplier', headerName: t(`global.supplier`), minWidth: 250 },
      { field: 'warehouse_code', headerName: t(`global.warehouse`), minWidth: 250 }
    ],
    t,
    'entities.accessor'
  );
};
